/* assets/form-error-a11y.js — A11Y-05-FORM-ERROR-06 (Shared locale errors and delegated interaction) */
(function (window, document) {
  'use strict';

  var VERSION = '2026-10-02-A11Y-05-FORM-ERROR-06';
  var GLOBAL_KEY = '__LITTLEG_A11Y_05_FORM_ERROR__';
  var FORM_SELECTOR = 'form.a11y-form-errors, form[data-a11y-form-errors]';
  var FIELD_SELECTOR = 'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])';

  if (!window || !document || window[GLOBAL_KEY] === VERSION) return;
  window[GLOBAL_KEY] = VERSION;

  function list(scope, selector) {
    return scope && scope.querySelectorAll ? Array.prototype.slice.call(scope.querySelectorAll(selector)) : [];
  }

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return clean(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function isFieldVisible(field) {
    if (!field || field.disabled || field.closest('[hidden],[inert]')) return false;
    return field.getAttribute('aria-hidden') !== 'true';
  }

  function labelFor(field) {
    var aria = clean(field.getAttribute('aria-label'));
    if (aria) return aria;

    var labelledBy = clean(field.getAttribute('aria-labelledby'));
    if (labelledBy) {
      var text = labelledBy.split(/\s+/).map(function (id) {
        var node = document.getElementById(id);
        return node ? clean(node.textContent) : '';
      }).filter(Boolean).join(' ');
      if (text) return text;
    }

    if (field.id) {
      var label = field.form && field.form.querySelector ? field.form.querySelector('label[for="' + cssEscape(field.id) + '"]') : null;
      if (label && clean(label.textContent)) {
        return clean(label.textContent).replace(/\s*\*\s*$/, '');
      }
    }

    return clean(field.placeholder) || words(field, 'this field', '此栏位', '此欄位');
  }

  function words(node, en, hans, hant) {
    var owner = node && node.closest ? node.closest('[lang]') : null;
    var lang = clean(owner && owner.getAttribute('lang') || document.documentElement.lang).toLowerCase();
    if (/^zh-(?:cn|hans|sg)(?:-|$)/.test(lang)) return hans;
    return /^zh(?:-|$)/.test(lang) ? hant : en;
  }

  function messageFor(field) {
    var label = labelFor(field);
    var v = field.validity || {};
    var minLength = field.getAttribute('minlength') || 0;
    if (v.valueMissing && field.type === 'checkbox') return words(field, 'Please confirm ' + label + '.', '请确认' + label + '。', '請確認' + label + '。');
    if (v.valueMissing) return words(field, 'Please enter ' + label + '.', '请填写' + label + '。', '請填寫' + label + '。');
    if (v.typeMismatch && field.type === 'email') return words(field, 'Enter a valid email address, such as name@company.com.', '请输入有效的邮箱地址，例如 name@company.com。', '請輸入有效的電郵地址，例如 name@company.com。');
    if (v.typeMismatch && field.type === 'url') return words(field, 'Enter a valid URL including https://.', '请输入有效的网址，包含 https://。', '請輸入有效的網址，包含 https://。');
    if (v.tooShort) return words(field, label + ' must contain at least ' + minLength + ' characters.', label + '至少需要 ' + minLength + ' 个字符。', label + '至少需要 ' + minLength + ' 個字元。');
    if (v.patternMismatch) return words(field, 'Check the format of ' + label + '.', '请检查' + label + '的格式。', '請檢查' + label + '的格式。');
    if (v.customError && clean(field.validationMessage)) return clean(field.validationMessage);
    return clean(field.validationMessage) || words(field, 'Check ' + label + '.', '请检查' + label + '。', '請檢查' + label + '。');
  }

  function ensureFieldId(form, field, index) {
    if (field.id) return field.id;
    var base = clean(form.id || form.dataset.a11yFormId || 'A11yForm').replace(/[^a-zA-Z0-9_-]/g, '-');
    field.id = base + '-Field-' + (index + 1);
    return field.id;
  }

  function describedByTokens(field) {
    return clean(field.getAttribute('aria-describedby')).split(/\s+/).filter(Boolean);
  }

  function addDescription(field, id) {
    var tokens = describedByTokens(field);
    if (tokens.indexOf(id) === -1) tokens.push(id);
    field.setAttribute('aria-describedby', tokens.join(' '));
  }

  function removeDescription(field, id) {
    var tokens = describedByTokens(field).filter(function (token) { return token !== id; });
    if (tokens.length) field.setAttribute('aria-describedby', tokens.join(' '));
    else field.removeAttribute('aria-describedby');
  }

  function fieldContainer(field) {
    return field.closest('.contact-portal__field, .field, [data-a11y-field]') || field.parentElement;
  }

  function errorIdFor(field) {
    return field.id + '-A11yError';
  }

  function setFieldError(form, field, message, index) {
    var id = ensureFieldId(form, field, index);
    var errorId = errorIdFor(field);
    var error = document.getElementById(errorId);

    field.setAttribute('aria-invalid', 'true');
    addDescription(field, errorId);

    if (!error) {
      error = document.createElement('p');
      error.id = errorId;
      error.className = 'a11y-field-error';
      error.setAttribute('data-a11y-generated-error', 'true');
      error.innerHTML = '<span class="a11y-field-error__icon" aria-hidden="true">!</span><span></span>';
      var container = fieldContainer(field);
      if (container) container.appendChild(error);
    }

    var text = error.querySelector('span:last-child');
    if (text) text.textContent = message;
    else error.textContent = message;

    return { field: field, fieldId: id, message: message };
  }

  function clearFieldError(field) {
    var errorId = field.id ? errorIdFor(field) : '';
    var generated = errorId ? document.getElementById(errorId) : null;
    if (generated && generated.hasAttribute('data-a11y-generated-error')) {
      generated.remove();
    }
    removeDescription(field, errorId);
    field.removeAttribute('aria-invalid');
  }

  function ensureSummary(form) {
    var summary = form.querySelector('[data-form-error-summary]');
    if (summary) {
      if (!summary.hasAttribute('tabindex')) summary.setAttribute('tabindex', '-1');
      summary.setAttribute('role', 'alert');
      summary.setAttribute('aria-live', 'assertive');
      return summary;
    }

    summary = document.createElement('div');
    summary.className = 'contact-portal__message contact-portal__message--error';
    summary.hidden = true;
    summary.setAttribute('data-form-error-summary', 'true');
    summary.setAttribute('data-a11y-generated-summary', 'true');
    summary.setAttribute('tabindex', '-1');
    summary.setAttribute('role', 'alert');
    summary.setAttribute('aria-live', 'assertive');
    form.insertBefore(summary, form.firstChild);
    return summary;
  }

  function summaryHeading(form) {
    var headingNode = form.querySelector('[data-a11y-error-heading]');
    return clean(form.dataset.a11yErrorHeading)
      || (headingNode ? clean(headingNode.textContent) : '')
      || words(form, 'Please check these fields', '请检查以下栏位', '請檢查以下欄位');
  }

  function renderSummary(form, issues) {
    var summary = ensureSummary(form);

    if (!issues.length) {
      summary.hidden = true;
      if (summary.hasAttribute('data-a11y-generated-summary')) summary.textContent = '';
      return summary;
    }

    summary.hidden = false;
    summary.innerHTML = '';

    var strong = document.createElement('strong');
    strong.textContent = summaryHeading(form) + ' (' + issues.length + ')';
    summary.appendChild(strong);

    var ul = document.createElement('ul');
    issues.forEach(function (issue) {
      var li = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + issue.fieldId;
      link.textContent = issue.message;
      li.appendChild(link);
      ul.appendChild(li);
    });
    summary.appendChild(ul);
    return summary;
  }

  function refreshErrorSummary(form) {
    const remaining = list(form, '[aria-invalid="true"]')
      .filter(isFieldVisible)
      .map((invalid, index) => ({
        field: invalid,
        fieldId: ensureFieldId(form, invalid, index),
        message: messageFor(invalid)
      }));

    renderSummary(form, remaining);
  }

  function moveToField(field) {
    if (!field || typeof field.focus !== 'function') return;
    window.requestAnimationFrame(function () {
      try { field.scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' }); } catch (_) { field.scrollIntoView(); }
      window.setTimeout(function () {
        if (!field.isConnected || !isFieldVisible(field)) return;
        try { field.focus({ preventScroll: true }); } catch (_) { field.focus(); }
      }, 150);
    });
  }

  function validate(form) {
    var invalid = list(form, FIELD_SELECTOR).filter(function (field) {
      if (!isFieldVisible(field)) return false;
      return field.willValidate !== false && typeof field.checkValidity === 'function' && !field.checkValidity();
    });

    var issues = invalid.map(function (field, index) {
      return setFieldError(form, field, messageFor(field), index);
    });

    renderSummary(form, issues);
    return issues;
  }

  function bind(form) {
    if (!form || form.dataset.a11yFormErrorReady === VERSION) return;
    form.dataset.a11yFormErrorReady = VERSION;
    form.noValidate = true;

    const enquiryDetails = form.closest ? form.closest('details[data-a11y-form-disclosure]') : null;
    if (enquiryDetails) {
      const success = form.querySelector('[data-contact-submission-success]');
      const serverError = form.querySelector('[data-form-error-summary]');
      const hasServerError = serverError &&
        !serverError.hidden &&
        !serverError.hasAttribute('data-a11y-generated-summary') &&
        clean(serverError.textContent) !== '';

      if (success || hasServerError) {
        enquiryDetails.open = true;
      }
    }

    /* 阻止原生氣泡 */
    form.addEventListener('invalid', function (event) {
      event.preventDefault();
    }, true);

    form.addEventListener('submit', function (event) {
      var issues = validate(form);
      if (!issues.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      moveToField(issues[0].field);
    }, true);

    form.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('[data-a11y-generated-summary] a, [data-form-error-summary] a') : null;
      if (!link || !form.contains(link)) return;
      var target = document.getElementById(clean(link.getAttribute('href')).replace(/^#/, ''));
      if (!target || target.form !== form) return;
      event.preventDefault();
      moveToField(target);
    });

    const clearResolvedFieldError = (event) => {
      const field = event.target;

      if (!field || !field.matches ||
          !field.matches(FIELD_SELECTOR) || field.form !== form) return;

      if (field.getAttribute('aria-invalid') !== 'true' ||
          !field.validity || !field.validity.valid) return;

      clearFieldError(field);

      refreshErrorSummary(form);
    };

    form.addEventListener('input', clearResolvedFieldError);

    form.addEventListener('contact:mode-change', function () {
      var hiddenErrors = list(form, '[aria-invalid="true"]').filter(function (field) {
        return !!field.closest('[hidden]');
      });
      if (!hiddenErrors.length) return;

      hiddenErrors.forEach(clearFieldError);
      refreshErrorSummary(form);
    });
  }

  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(FORM_SELECTOR)) bind(target);
    list(target, FORM_SELECTOR).forEach(bind);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
})(window, document);
